// extracted by mini-css-extract-plugin
export default {"form":"tap_create_form__RqU1e","tabs":"tap_create_tabs__NQPOs"};